<template>
  <editor :id="id" default-tab="running_order" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import RunningOrderEditor from './RunningOrderEditor'
export default {
  props: ['id'],
  components: {
    Editor
  },
  data() {
    return {
      tabs: [
        {title: "Running Order", name: "running_order", component: RunningOrderEditor}
      ]
    }
  }
}
</script>
